/* eslint-disable import/no-anonymous-default-export*/
// eslint-disable import/no-anonymous-default-export
// File was autogenerated by tools/generateLabels.js script
import ResourceService from '../../services/resourceService';
const _ = (path:string) => ():string => ResourceService.get(path);

export default {
        AbortProcess: _('labels.AbortProcess'),
        Accept: _('labels.Accept'),
        AccountConfirmedMessage: _('labels.AccountConfirmedMessage'),
        AccountNotConfirmedMessage: _('labels.AccountNotConfirmedMessage'),
        ActualProgram: _('labels.ActualProgram'),
        AddReceiptPhoto: _('labels.AddReceiptPhoto'),
        AddingReciptPhotoIsRequired: _('labels.AddingReciptPhotoIsRequired'),
        AdministratorOfYourDataIsMessage: _('labels.AdministratorOfYourDataIsMessage'),
        AllOffers: _('labels.AllOffers'),
        ApartmentNumber: _('labels.ApartmentNumber'),
        AvfaliableOffers: _('labels.AvfaliableOffers'),
        Back: _('labels.Back'),
        CancelCustomerRegistrationProcessQuestion: _('labels.CancelCustomerRegistrationProcessQuestion'),
        ChangePassword: _('labels.ChangePassword'),
        ChangePasswordSuccessInfo: _('labels.ChangePasswordSuccessInfo'),
        ChooseAccountType: _('labels.ChooseAccountType'),
        ChooseOffer: _('labels.ChooseOffer'),
        City: _('labels.City'),
        ClerkRegistrationComplete: _('labels.ClerkRegistrationComplete'),
        ClickAndEnterDeviceToReceiveCode: _('labels.ClickAndEnterDeviceToReceiveCode'),
        ClickAndLearnMoreAboutDataProtection: _('labels.ClickAndLearnMoreAboutDataProtection'),
        Close: _('labels.Close'),
        ClosePreview: _('labels.ClosePreview'),
        Commune: _('labels.Commune'),
        CompanyApartmentNumber: _('labels.CompanyApartmentNumber'),
        CompanyBuildingNumber: _('labels.CompanyBuildingNumber'),
        CompanyCity: _('labels.CompanyCity'),
        CompanyName: _('labels.CompanyName'),
        CompanyPostalCode: _('labels.CompanyPostalCode'),
        CompanyStreet: _('labels.CompanyStreet'),
        Confirm: _('labels.Confirm'),
        ConfirmAccount: _('labels.ConfirmAccount'),
        ConfirmAdult: _('labels.ConfirmAdult'),
        ConfirmPassword: _('labels.ConfirmPassword'),
        ConfirmRegulations: _('labels.ConfirmRegulations'),
        ConfirmSale: _('labels.ConfirmSale'),
        ConsentsRequired: _('labels.ConsentsRequired'),
        Counter: _('labels.Counter'),
        Country: _('labels.Country'),
        CustomerAlreadyRegistered: _('labels.CustomerAlreadyRegistered'),
        CustomerAlreadyRegistred: _('labels.CustomerAlreadyRegistred'),
        CustomerNotYetRegistered: _('labels.CustomerNotYetRegistered'),
        CustomerRegistrationTimeout: _('labels.CustomerRegistrationTimeout'),
        DateOfBirth: _('labels.DateOfBirth'),
        DealerCode: _('labels.DealerCode'),
        DeleteReceiptPhotoConfirmation: _('labels.DeleteReceiptPhotoConfirmation'),
        DeviceNumber: _('labels.DeviceNumber'),
        DeviceRegistrationFailure: _('labels.DeviceRegistrationFailure'),
        DoYouHaveAccount: _('labels.DoYouHaveAccount'),
        EditProfile: _('labels.EditProfile'),
        Email: _('labels.Email'),
        EmailAlreadyExists: _('labels.EmailAlreadyExists'),
        EmailShort: _('labels.EmailShort'),
        EnterDeviceData: _('labels.EnterDeviceData'),
        EnterOwnedDeviceNumber: _('labels.EnterOwnedDeviceNumber'),
        EnterPhoneNumber: _('labels.EnterPhoneNumber'),
        EnterPhoneNumberToVerifyAvailabilityOfPromotionalOffer: _('labels.EnterPhoneNumberToVerifyAvailabilityOfPromotionalOffer'),
        EnterPloomAuraDeviceNumber: _('labels.EnterPloomAuraDeviceNumber'),
        FirstName: _('labels.FirstName'),
        ForgotPassword: _('labels.ForgotPassword'),
        Form: _('labels.Form'),
        GatheredPoints: _('labels.GatheredPoints'),
        GetData: _('labels.GetData'),
        GetPointOfSaleData: _('labels.GetPointOfSaleData'),
        Here: _('labels.Here'),
        HideProgramRegulations: _('labels.HideProgramRegulations'),
        HomeNumber: _('labels.HomeNumber'),
        IConfirmTheSaleOfTheOffer: _('labels.IConfirmTheSaleOfTheOffer'),
        InformationClause: _('labels.InformationClause'),
        InformationOnPersonalDataProtection: _('labels.InformationOnPersonalDataProtection'),
        Install: _('labels.Install'),
        LastName: _('labels.LastName'),
        LegalPerson: _('labels.LegalPerson'),
        LinkExpired: _('labels.LinkExpired'),
        LogIn: _('labels.LogIn'),
        Logging: _('labels.Logging'),
        LoginPageGreetingsContinuation: _('labels.LoginPageGreetingsContinuation'),
        LoginPageLoginOrRegister: _('labels.LoginPageLoginOrRegister'),
        Logout: _('labels.Logout'),
        MakeSureYouHaveProvideTheCustomerWith: _('labels.MakeSureYouHaveProvideTheCustomerWith'),
        Menu: _('labels.Menu'),
        NavigateGoogleMaps: _('labels.NavigateGoogleMaps'),
        NewPassword: _('labels.NewPassword'),
        Next: _('labels.Next'),
        Nip: _('labels.Nip'),
        No: _('labels.No'),
        NoActiveProgram: _('labels.NoActiveProgram'),
        NoOffer: _('labels.NoOffer'),
        OfferMapTitle: _('labels.OfferMapTitle'),
        OfferPortfolio: _('labels.OfferPortfolio'),
        OfferRegulation: _('labels.OfferRegulation'),
        OfferSale: _('labels.OfferSale'),
        OfferSaleCancelation: _('labels.OfferSaleCancelation'),
        OffersRegulations: _('labels.OffersRegulations'),
        OldPasswrod: _('labels.OldPasswrod'),
        OptionalCommentHint: _('labels.OptionalCommentHint'),
        Password: _('labels.Password'),
        Pesel: _('labels.Pesel'),
        PhoneNumber: _('labels.PhoneNumber'),
        PhysicalPerson: _('labels.PhysicalPerson'),
        PlatformRegulations: _('labels.PlatformRegulations'),
        Ploom: _('labels.Ploom'),
        PloomRegistrationHeader: _('labels.PloomRegistrationHeader'),
        PointOfSaleCode: _('labels.PointOfSaleCode'),
        PostOffice: _('labels.PostOffice'),
        PostalCode: _('labels.PostalCode'),
        Preview: _('labels.Preview'),
        PrivacyPolicy: _('labels.PrivacyPolicy'),
        ProcessCanceledBySeller: _('labels.ProcessCanceledBySeller'),
        Profile: _('labels.Profile'),
        ProgramArchive: _('labels.ProgramArchive'),
        ProgramRegulations: _('labels.ProgramRegulations'),
        ProgramsForYou: _('labels.ProgramsForYou'),
        PromoCode: _('labels.PromoCode'),
        ProvideSalePointCode: _('labels.ProvideSalePointCode'),
        Pts: _('labels.Pts'),
        QRSalePoint: _('labels.QRSalePoint'),
        QuickApplicationGuide: _('labels.QuickApplicationGuide'),
        ReceiptPhoto: _('labels.ReceiptPhoto'),
        Refresh: _('labels.Refresh'),
        Register: _('labels.Register'),
        RegistrationFailure: _('labels.RegistrationFailure'),
        RegistrationSuccess: _('labels.RegistrationSuccess'),
        RegistrationSuccessZabka: _('labels.RegistrationSuccessZabka'),
        Regulation: _('labels.Regulation'),
        Regulations: _('labels.Regulations'),
        RememberMe: _('labels.RememberMe'),
        Remove: _('labels.Remove'),
        RepeatEmail: _('labels.RepeatEmail'),
        RestorePassword: _('labels.RestorePassword'),
        RestorePasswordInfo: _('labels.RestorePasswordInfo'),
        Reward: _('labels.Reward'),
        RtNumber: _('labels.RtNumber'),
        SaleFailedMessage: _('labels.SaleFailedMessage'),
        SaleSuccessfulMessage: _('labels.SaleSuccessfulMessage'),
        SaleSuccessfullAdditionalWarning: _('labels.SaleSuccessfullAdditionalWarning'),
        Save: _('labels.Save'),
        SavedSuccessFully: _('labels.SavedSuccessFully'),
        ScanOrEnterTheQrCodeOfTheDevice: _('labels.ScanOrEnterTheQrCodeOfTheDevice'),
        ScanOrEnterTheQrCodeOfThePointWhereYouAreCurrentlyWorking: _('labels.ScanOrEnterTheQrCodeOfThePointWhereYouAreCurrentlyWorking'),
        SearchForCode: _('labels.SearchForCode'),
        SelectOffer: _('labels.SelectOffer'),
        SelectOfferInfo: _('labels.SelectOfferInfo'),
        SelectProgram: _('labels.SelectProgram'),
        SelectedOffer: _('labels.SelectedOffer'),
        SellOfferProcessInProgress: _('labels.SellOfferProcessInProgress'),
        SendLink: _('labels.SendLink'),
        ShowLess: _('labels.ShowLess'),
        ShowMore: _('labels.ShowMore'),
        ShowProgramRegulations: _('labels.ShowProgramRegulations'),
        StoreCode: _('labels.StoreCode'),
        StoreNumber: _('labels.StoreNumber'),
        Street: _('labels.Street'),
        TaxOffice: _('labels.TaxOffice'),
        TermsAndConditions: _('labels.TermsAndConditions'),
        ThanksForUsingOffer: _('labels.ThanksForUsingOffer'),
        TheOrganizerOfThePromotionIsJtiPoland: _('labels.TheOrganizerOfThePromotionIsJtiPoland'),
        TradeInFormHeader: _('labels.TradeInFormHeader'),
        TradeInSuccessfull: _('labels.TradeInSuccessfull'),
        TransactionCancelledByClerk: _('labels.TransactionCancelledByClerk'),
        Verify: _('labels.Verify'),
        Voivodeship: _('labels.Voivodeship'),
        WaitForClientRegisterMessage: _('labels.WaitForClientRegisterMessage'),
        Welcome: _('labels.Welcome'),
        WrongRegistrationUrl: _('labels.WrongRegistrationUrl'),
        Yes: _('labels.Yes'),
        YouCanFindRegulationLink: _('labels.YouCanFindRegulationLink'),
        YourEmail: _('labels.YourEmail'),
        YourPoints: _('labels.YourPoints'),
        ZabkaRegisterDeviceViewMessage: _('labels.ZabkaRegisterDeviceViewMessage'),
};
